import { Slide } from '@/components/core/Slide';
import audioFile from './28-recommendations.mp3';

const autoNextDuration = 60000;
const transcript = `
  Laat me het nog eens op een rijtje zetten. Hier zijn praktische aanbevelingen om AI enabled te worden:

  Ten eerste, begin klein en concreet. Start met één specifiek probleem, zoals klantenservice of onderhoudsplanning.

  Ten tweede, breng je data op orde. Goede digitale infrastructuur en betrouwbare data zijn essentieel.

  Ten derde, train medewerkers in AI-vaardigheden. Zorg voor draagvlak en verminder angst voor technologie.

  Ten vierde, ontwikkel een langetermijnvisie. AI is geen eenmalige stap, maar een continu verbeterproces 
  waarin mens en techniek elkaar versterken.

  En tot slot, maak gebruik van beschikbare steun. Benut subsidies, netwerken 
  en samenwerkingen met scholen... 
  
  Maak vooral gebruik van de quick scan en het ontwikkeltraject, 
  die jullie kosteloos kunnen aanvragen bij de Techniekcoalitie Brabant. Laat je helpen. 
`;

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-10">🚀 Praktische Aanbevelingen</h1>
        <ul className="space-y-6 text-3xl list-disc">
          <li>Begin klein en concreet: Start met één specifiek probleem</li>
          <li>Breng je data op orde: Goede digitale infrastructuur is essentieel</li>
          <li>Train medewerkers: Zorg voor draagvlak en verminder angst</li>
          <li>Ontwikkel langetermijnvisie: Continu verbeterproces</li>
          <li>Benut beschikbare steun: Subsidies, netwerken, samenwerkingen</li>
          <li className="text-blue-400">
            Vraag kosteloos de quick scan en ontwikkeltraject aan bij Techniekcoalitie Brabant
          </li>
        </ul>
      </div>
    </Slide>
  );
};
